import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/AddressProgramArchived/AdjustmentApi";
import i18n from "../../../../Frontends/Common/utils/i18n.js";
import store from "../../../../Frontends/Common/store";

export class AdjustmentService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
    this.editedFields = [];
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editAdjustment", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editAdjustment");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getAdjustments", args);
  }
  async get(id, periodId) {
    return await this.transformer.getGridPanel(this.Api, "getAdjustment", null, { id, periodId });
  }
  async getMany(ids, periodId) {
    let filter = "$filter=MarsPeriodId eq " + periodId + " and (" + ids.map(id => `(Id eq ${id})`).join(" or ") + ")";
    return await this.transformer.getGrid(this.Api, "getAdjustments", filter);
  }
  async getAddressProgramsByAdjustmentId(filter) {
    return await this.transformer.getGrid(this.Api, "getAddressProgramsByAdjustmentId", filter);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createAdjustment", model);
  }
  async acceptAdjustment(model) {
    return await this.transformer.editItem(this.Api, "acceptAdjustment", model);
  }
  async approveAdjustment(model) {
    return await this.transformer.editItem(this.Api, "approveAdjustment", model);
  }
  async acceptAdjustments(params) {
    return await this.transformer.editItem(this.Api, "acceptAdjustments", params);
  }
  async approveAdjustments(params) {
    return await this.transformer.editItem(this.Api, "approveAdjustments", params);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editAdjustment", model);
  }
  async updateMany(models) {
    return await this.transformer.editItem(this.Api, "editAdjustments", models);
  }
  async delete(models) {
    return await this.transformer.deleteItem(this.Api, "deleteAdjustments", models);
  }
  async getEditedFieldsConfig() {
    let data = this.editedFields || [];
    return { data: { records: data, total: data.length } };
  }
  async getTypes() {
    const types = [
      { label: i18n.global.t("adjustmentTT"), value: "adjustmentTT" },
      { label: i18n.global.t("adjustmentGroupTT"), value: "adjustmentGroupTT" },
    ]
    const data = {records: types}
    return Promise.resolve( { data })
  }
  async getEditedFields() {
    const types = [
      { label: "Сеть", value: "Сеть" },
      { label: "Адрес", value: "Адрес" },
      { label: "Область", value: "Область" },
      { label: "Город", value: "Город" },
      { label: "Географический кластер", value: "Географический кластер" },
      { label: "RSM", value: "RSM" },
      { label: "Внешний формат", value: "Внешний формат" },
      { label: "Тип точки", value: "Тип точки" },
      { label: "Канал", value: "Канал" },
      { label: "NA/RKA", value: "NA/RKA" },
      { label: "SIP-канал", value: "SIP-канал" },
      { label: "Территориальный кластер", value: "Территориальный кластер" },
      { label: "Внешний код", value: "Внешний код" },
      { label: "Тарифная зона", value: "Тарифная зона" },
      { label: "Skyline", value: "Skyline" },
      { label: "Количество визитов", value: "Кол-во визитов" },
      { label: "Нормативное время визита", value: "Нормативное время визита" },
      { label: "OSA", value: "OSA" },
      { label: "ISA-OSA", value: "ISA-OSA" },
      { label: "PSS", value: "PSS" },
      { label: "Тактическая задача", value: "Тактическая задача" },
      { label: "Ставка нормочаса", value: "Ставка нормочаса" },
      { label: "Покрытие", value: "Покрытие"}
    ]
    const data = {records: types}
    return Promise.resolve( { data })
  }
  async getResultFilterTypes() {
    const filter = [
      { text: i18n.global.t("adjustmentFieldAccepted"), value: true },
      { text: i18n.global.t("adjustmentFieldDeclined"), value: false }
    ];
    return Promise.resolve({ data: { records: filter } });
  }
  async export(period, filter, format) {
    const res = this.Api.export(period, filter, format);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async getHasAdjustmentFilterCoverage() {
    const hasAdjustmentFilterCoverage = [
      { text: i18n.global.t("inclusionInCoverage"), value: true },
      { text: i18n.global.t("exclusionFromCoverage"), value: false }
    ];
    return Promise.resolve({ data: { records: hasAdjustmentFilterCoverage } })
  }
}
